/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/count.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Returns the total number (count) of input values.',
  examples: [
    'FROM employees\n| STATS COUNT(height)',
    'FROM employees\n| STATS count = COUNT(*) BY languages\n| SORT languages DESC',
    'ROW words="foo;bar;baz;qux;quux;foo"\n| STATS word_count = COUNT(SPLIT(words, ";"))',
    'ROW n=1\n| WHERE n < 0\n| STATS COUNT(n)',
    'FROM employees\n| STATS\n    gte20 = COUNT(*) WHERE height >= 2,\n    lte18 = COUNT(*) WHERE height <= 1.8',
    'ROW mv = [1, 2], n = NULL, t = TRUE, f = FALSE\n| STATS COUNT(mv), COUNT(n), COUNT(t), COUNT(f)',
    'ROW n=1\n| STATS COUNT(n > 0 OR NULL), COUNT(n < 0 OR NULL)',
    'TS exp_histo_sample\n| WHERE instance == "instance-0"\n| STATS cnt = COUNT(responseTime)',
    'TS histogram_timeseries_index\n| WHERE instance == "instance-0"\n| STATS cnt = COUNT(responseTime::tdigest)',
  ],
  params: {
    field: 'Expression that outputs values to be counted. If omitted, equivalent to `COUNT(*)` (the number of rows).',
    bucket: 'Range of histogram values to count.',
  },
};

export default docs;
